/* global axios */

const knowledgeProxy = (accountId, path) =>
  `/api/v1/accounts/${accountId}/proxy/knowledge${path}`;

export const state = {
  overrides: [],
  selectedOverride: null,
  isLoading: false,
  isError: false,
};

export const getters = {};

export const mutations = {
  SET_OVERRIDES(state, overrides) { state.overrides = overrides; },
  SET_SELECTED_OVERRIDE(state, override) { state.selectedOverride = override; },
  SET_LOADING(state, isLoading) { state.isLoading = isLoading; },
  SET_ERROR(state, error) { state.isError = error; },
};

export const actions = {
  async fetchOverrides({ commit, rootGetters }, schedule_id) {
    const accountId = rootGetters.getCurrentAccountId;
    commit('SET_LOADING', true);
    commit('SET_ERROR', false);
    if (!schedule_id) throw new Error('Schedule ID is required to fetch overrides');

    try {
      const res = await axios.get(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/schedules/${schedule_id}/overrides`)
      );
      commit('SET_OVERRIDES', res.data);
      return res.data;
    } catch (error) {
      commit('SET_ERROR', true);
      throw error.response?.data || error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async createOverride({ rootGetters }, { schedule_id, overrideData }) {
    const accountId = rootGetters.getCurrentAccountId;
    if (!schedule_id) throw new Error('Schedule ID is required to create override');

    try {
      const res = await axios.post(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/schedules/${schedule_id}/overrides`),
        overrideData
      );
      return res.data;
    } catch (error) {
      console.error('Create override failed:', error);
      throw error.response?.data || error;
    }
  },

  async updateOverride({ rootGetters }, { schedule_id, overrideId, overrideData }) {
    const accountId = rootGetters.getCurrentAccountId;
    if (!schedule_id) throw new Error('Schedule ID is required to update override');
    if (!overrideId) throw new Error('Override ID is required');

    try {
      const res = await axios.patch(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/schedules/${schedule_id}/overrides/${overrideId}`),
        overrideData
      );
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async deleteOverride({ rootGetters }, { schedule_id, overrideId }) {
    const accountId = rootGetters.getCurrentAccountId;
    if (!schedule_id) throw new Error('Schedule ID is required to delete override');
    if (!overrideId) throw new Error('Override ID is required');

    try {
      const res = await axios.delete(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/schedules/${schedule_id}/overrides/${overrideId}`)
      );
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async fetchAllOverrides({ commit, rootGetters }, schedule_id) {
    const accountId = rootGetters.getCurrentAccountId;
    if (!schedule_id) throw new Error('Schedule ID is required to fetch all overrides');

    try {
      const res = await axios.get(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/schedules/${schedule_id}/overrides`)
      );
      commit('SET_OVERRIDES', res.data);
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async fetchOverride({ commit, rootGetters }, { schedule_id, overrideId }) {
    const accountId = rootGetters.getCurrentAccountId;
    if (!schedule_id) throw new Error('Schedule ID is required');
    if (!overrideId) throw new Error('Override ID is required');

    try {
      const res = await axios.get(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/schedules/${schedule_id}/overrides/${overrideId}`)
      );
      commit('SET_SELECTED_OVERRIDE', res.data);
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
